import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

let client: SupabaseClient | null = null;

function withLock<T>(name: string, acquireTimeout: number, fn: () => Promise<T>): Promise<T> {
  if (typeof navigator !== "undefined" && navigator.locks?.request) {
    return new Promise<T>((resolve, reject) => {
      let settled = false;
      const lockTimeout = acquireTimeout > 0 ? acquireTimeout : 10000;
      navigator.locks.request(name, { timeout: lockTimeout }, async (lock) => {
        try {
          const result = await fn();
          settled = true;
          resolve(result);
        } catch (err) {
          settled = true;
          reject(err);
        } finally {
          if (lock) {
            // lock released automatically
          }
        }
      }).catch((err) => {
        if (!settled) {
          reject(err);
        }
      });
    });
  }
  return fn();
}

export function getSupabase(): SupabaseClient {
  if (!client) {
    client = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        lock: withLock,
      },
    });
  }
  return client;
}

export const supabase = getSupabase();